import axios from "axios";
import { serverURL,headeroption,headeroptionupload } from "../http-common";

class PrincipalService {
  getallPrincipal(data) {
    return axios.get(serverURL + "/principal-api?req=smarttablePrincipal", {
      params: data,
      headers: headeroption,
    })
  }
  getPrincipal(principal_id) {
    return axios.get(serverURL + "/principal-api?req=getPrincipal", {
      params: { principal_id: principal_id }, headers: headeroption,
    });
  }
  createPrincipal(data) {
    return axios.post(serverURL + "/principal-api?req=createPrincipal", data, {
      headers: headeroption,
    });
  }
  updatePrincipal(data) {
    return axios.put(serverURL + "/principal-api?req=updatePrincipal", data, {
      headers: headeroption,
    });
  }
  deletePrincipal(principal_id) {
    return axios.delete(serverURL + "/principal-api?req=deletePrincipal", { params: { principal_id: principal_id }, headers: headeroption, });
  }
  deleteAll() {
    return axios.delete(serverURL + "/principal-api?req=deletePrincipal");
  }
  findByTitle(principal_name) {
    return axios.get(serverURL + "/principal/principal-api?name=" + principal_name);
  }
  upload(principal_id, data) {
    return axios.post(serverURL + "/uploads-api/singlefile?principal_id=" + principal_id, data, { headers: headeroptionupload });
  }
  uploads(principal_id, data) {
    return axios.post(serverURL + "/uploads-api/uploadmultifile?principal_id=" + principal_id, data, { headers: headeroptionupload });
  }
}
export default new PrincipalService();
